<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-07-11 16:38:40
 * @LastEditors: luckymiaow
-->
<script setup lang="ts">
import { nextTick, ref, watchEffect } from 'vue';
import useConfigProvider from '../../config-provider/src/useConfigProvider';
import type { AuthorImg, AuthorImgInjectConfig } from '../types';
import useAuthImg from '../hook/useAuthImg';

interface AuthorImgProps extends AuthorImg {
  authorization?: string;
  src?: string;
  defaultSrc?: string;
}

const props = withDefaults(defineProps<AuthorImgProps>(), {});

const imgRef = ref<HTMLImageElement>();

const { injectConfig } = useConfigProvider();

const config = injectConfig<AuthorImgInjectConfig>('AuthorImg', props);

watchEffect(async () => {
  await nextTick();
  let url = props.src;
  if (imgRef.value == null) return;
  if (!url && props.defaultSrc) {
    imgRef.value.src = props.defaultSrc;
  } else {
    useAuthImg(url as string, imgRef.value, config?.value?.authorization as string);
  }
});
defineExpose({ img: imgRef });
</script>

<template><img ref="imgRef" /></template>
